import gql from "graphql-tag";
import AssetDiscussionCommentRepliesPaginationFields from "../../fragments/AssetDiscussionCommentRepliesPaginationFields";

export default gql`
  query AssetDiscussionCommentReplies($rootCommentShortId: ID!, $cursor: Cursor!, $limit: Int! = 8) {
    assetDiscussionCommentByShortId(commentShortId: $rootCommentShortId) {
      __typename
      _id
      replies(cursor: $cursor, limit: $limit) {
        ...AssetDiscussionCommentRepliesPaginationFields
      }
    }
  }

  ${AssetDiscussionCommentRepliesPaginationFields}
`;
